<template>
  <div>
    <div class="head-box">
      <h4>系统操作日志</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入操作账号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          stripe
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column prop="type" label="日志类型"></el-table-column>
          <el-table-column prop="uaccount" label="操作账号"></el-table-column>
          <el-table-column prop="createTime" label="操作时间"></el-table-column>
          <el-table-column prop="memo" label="描述"></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'operationLogs',
  data() {
    return {
      fpi: {},
      searchValue: ''
    };
  },
  mounted() {
    window.$this = this;
    this.osg.getFpi();
    this.getData();
  },
  methods: {
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:uaccount|string#or': this.searchValue
      };
      this.osg.setFpi(params);
      this.osg.ajax('oplog/query.do', params, res => {
        if (res) {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      });
    }
  }
};
</script>
